
import { useState, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";


const Typewriter = ({ text, speed = 100 }) => {
  const [displayed, setDisplayed] = useState("");

useEffect(() => {
    setDisplayed("");
    let index = 0;
    const interval = setInterval(() => {
      setDisplayed(prev => prev + text[index]);
      index++;
      if (index >= text.length) clearInterval(interval);
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed]);

  return <h2 className="typewriter-react">{displayed}</h2>;
};


const AccueilHero = () => {
  const { t, i18n } = useTranslation();
  return (
    <section className="hero">
      <div className="hero-media">
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <h1 className="hero-title">
          Sophie Garant-Ducas
        </h1>

        <Typewriter
          text={t("job.title")}
          speed={90}
        />



        <p className="hero-description">
          {t("intro")}
        </p>
        <div className="upk-salf-button " data-swiper-parallax-y="-300" data-swiper-parallax-duration="1500">
          <a className="link link--arrowed " href="#techno-section"><b>{t("btn.competences")}</b>
            <svg className="arrow-icon ms-3" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 32 32">
              <g fill="none" stroke="rgb(41, 41, 81)" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10">
                <circle className="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                <path className="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
              </g>
            </svg>
          </a>
        </div>

      </div>
    </section>
  );
};

export default AccueilHero;
